import card_03 from "../../../../public/swipper/card_03.png";
import card_04 from "../../../../public/swipper/card_04.png";
import card_05 from "../../../../public/swipper/card_05.png";
import card_06 from "../../../../public/swipper/card_06.png";
import card_07 from "../../../../public/swipper/card_07.png";
import card_08 from "../../../../public/swipper/card_08.png";
import card_09 from "../../../../public/swipper/card_09.png";
import card_10 from "../../../../public/swipper/card_10.png";
import card_11 from "../../../../public/swipper/card_11.png";
import card_12 from "../../../../public/swipper/card_12.png";
import card_13 from "../../../../public/swipper/card_13.png";
import card_14 from "../../../../public/swipper/card_14.png";
import card_15 from "../../../../public/swipper/card_15.png";
import card_16 from "../../../../public/swipper/card_16.png";
import card_17 from "../../../../public/swipper/card_17.png";
import card_18 from "../../../../public/swipper/card_18.png";
import card_19 from "../../../../public/swipper/card_19.png";
import card_20 from "../../../../public/swipper/card_20.png";
import card_21 from "../../../../public/swipper/card_21.png";
import card_22 from "../../../../public/swipper/card_22.png";
import card_23 from "../../../../public/swipper/card_23.png";
import card_24 from "../../../../public/swipper/card_24.png";
import card_25 from "../../../../public/swipper/card_25.png";
import card_26 from "../../../../public/swipper/card_26.png";
import card_27 from "../../../../public/swipper/card_27.png";
import card_28 from "../../../../public/swipper/card_28.png";
import card_29 from "../../../../public/swipper/card_29.png";
import card_30 from "../../../../public/swipper/card_30.png";
import card_31 from "../../../../public/swipper/card_31.png";
import card_32 from "../../../../public/swipper/card_32.png";
import card_33 from "../../../../public/swipper/card_33.png";
import card_34 from "../../../../public/swipper/card_34.png";
import card_35 from "../../../../public/swipper/card_35.png";
import card_36 from "../../../../public/swipper/card_36.png";
import card_37 from "../../../../public/swipper/card_37.png";
import unlocked_level from "../../../../public/swipper/unlocked_level.png";
import lock_icon from "../../../../public/swipper/lock_icon.png";
import unselected_icon from "../../../../public/swipper/non_selected_level.png";

export const data = [
  {
    icon: card_03,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: false,
  },
  {
    icon: card_04,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: false,
  },
  {
    icon: card_05,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: true,
  },
  // {
  //   icon: card_06,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_07,
  //   locked: false,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  {
    icon: card_08,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: false,
  },
  // {
  //   icon: card_09,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_10,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_11,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_12,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_13,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  {
    icon: card_14,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: false,
  },
  // {
  //   icon: card_15,
  //   locked: false,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_16,
  //   locked: false,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_17,
  //   locked: false,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_18,
  //   locked: false,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_19,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_20,
  //   locked: false,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_21,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_22,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_23,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_24,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  {
    icon: card_25,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: false,
  },
  // {
  //   icon: card_26,
  //   locked: false,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  {
    icon: card_27,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: false,
  },
  // {
  //   icon: card_28,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_29,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_30,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_31,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_32,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_33,
  //   locked: false,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  {
    icon: card_34,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: false,
  },
  {
    icon: card_35,
    locked: false,
    selected_icon: unlocked_level,
    lock_icon: lock_icon,
    unselected_icon: unselected_icon,
    selected: false,
  },
  // {
  //   icon: card_36,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
  // {
  //   icon: card_37,
  //   locked: true,
  //   selected_icon: unlocked_level,
  //   lock_icon: lock_icon,
  //   unselected_icon: unselected_icon,
  //   selected: false,
  // },
];
